import { urijs } from '@wix/communities-blog-client-common';

export default function getVideoEmbedThumbUrl({ thumbnail_url }) {
  return urijs(thumbnail_url).protocol('').toString();
}
